module.exports = __webpack_public_path__ + "img/mindful.5583a48.svg";